var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMarketPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM16.583 6.09071C17.421 5.73156 18.2683 6.57888 17.9092 7.4169L15.0766 14.0263C14.8743 14.4983 14.4982 14.8744 14.0261 15.0767L7.41678 17.9093C6.57877 18.2684 5.73143 17.4211 6.09059 16.5831L8.92317 9.97374C9.12547 9.50171 9.50159 9.12559 9.97362 8.92329L16.583 6.09071ZM10.7615 10.7615L10.7615 10.7616L8.90383 15.0961L13.2383 13.2384L13.2383 13.2383L10.7615 10.7615Z",
    fill: "#292F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarketPlace);
export default __webpack_public_path__ + "static/media/ic_market-place.ba3fc928ac9df11cf3c78be9cef8f448.svg";
export { ForwardRef as ReactComponent };